import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "../../components/ui-components/Toast";
import * as api from "./api";

export const invKeys = { all: ["investigations"], one: (id) => ["investigation", id] };

export function useInvestigationsQuery() {
  return useQuery({ queryKey: invKeys.all, queryFn: api.listInvestigations, select: (d) => d?.investigations ?? [] });
}
export function useInvestigationQuery(id) {
  return useQuery({ queryKey: invKeys.one(id), queryFn: () => api.getInvestigation(id), select: (d) => d?.investigation, enabled: !!id });
}
export function usePreviewMutation() {
  return useMutation({ mutationFn: (seed) => api.previewInvestigation(seed), // returns { decomposition }
    onError: (e) => toast.error(e?.serverBody?.error?.message || e?.message || "Preview failed") });
}
export function useCreateInvestigationMutation() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: ({ title, seed }) => api.createInvestigation(title, seed),
    onSuccess: () => qc.invalidateQueries(invKeys.all),
    onError: (e) => toast.error(e?.serverBody?.error?.message || e?.message || "Create failed") });
}
export function useRerunMutation(id) {
  const qc = useQueryClient();
  return useMutation({ mutationFn: () => api.rerunInvestigation(id),
    onSuccess: () => { toast.success("Re-ran investigation"); qc.invalidateQueries(invKeys.one(id)); },
    onError: (e) => toast.error(e?.message || "Re-run failed") });
}
export function usePatchMutation(id) {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (patch) => api.patchInvestigation(id, patch),
    onSuccess: () => { qc.invalidateQueries(invKeys.one(id)); qc.invalidateQueries(invKeys.all); },
    onError: (e) => toast.error(e?.serverBody?.error?.message || e?.message || "Update failed") });
}
export function useActionMutation(id) {
  const qc = useQueryClient();
  return useMutation({ mutationFn: ({ kind, targetRef }) => api.createAction(id, kind, targetRef),
    onSuccess: () => { toast.success("Action created"); qc.invalidateQueries(invKeys.one(id)); },
    onError: (e) => toast.error(e?.message || "Action failed") });
}
